import { s } from '@search/router/src/schema';
import { SusaninRoute } from '@search/router/src/susanin/SusaninRoute';
import type { Tokens } from '@search/router/src/RouterInterfaces';

import type { INewBuildingRouterContext as IRouterContext } from '../types';

export const NewBuildingQuizType = s.rec({
    id: s.nullOpt(s.str)
});

export type INewBuildingQuizType = ReturnType<typeof NewBuildingQuizType>

export const NewBuildingQuizSeoType = s.rec({
    origin: s.nullOpt(s.str),
    id: s.nullOpt(s.str)
});

export type INewBuildingQuizSeoType = ReturnType<typeof NewBuildingQuizSeoType>

export class NewBuildingQuizRoute extends SusaninRoute<
    INewBuildingQuizSeoType,
    INewBuildingQuizType,
    IRouterContext
> {
    displayName = 'NewBuildingQuizRoute';

    protected metadata = NewBuildingQuizSeoType.config;

    protected pattern(p: Tokens<INewBuildingQuizSeoType>) {
        return `${this.patternHost()}/novostroyki/quiz(/${p.id})/`;
    }

    protected conditions() {
        return {
            ...super.conditions(),
            id: '[\\w]+[-\\w]*'
        };
    }

    defaults() {
        return {};
    }

    protected fromQuery(seoParams: INewBuildingQuizSeoType) {
        return NewBuildingQuizType({
            id: seoParams.id
        });
    }

    protected toQuery(params: INewBuildingQuizType) {
        return NewBuildingQuizSeoType({
            id: params.id
        });
    }
}
